import * as React from 'react';
import { useState } from 'react';
import { publicClientFamilyPageUrl, publicClientInterestsPageUrl } from '../../../core/constants';
import Tile from '../../common/Tile';
import Helmet from '../../../commonComponents/Helmet';
import PublicAutoLogoutLayout from './common/PublicLayout';
import PublicPageSteps from './common/PublicPageSteps';
import PublicBusinessEntitiesGrid from './businessEntity/PublicBusinessEntitiesGrid';
import { useRequireProgress } from './common/PublicProgressContext';
import {
	ctxTermsAccepted,
	ctxClientTypeSelected,
	businessOwnerClientType,
	ctxClientBasicInfoCompleted
} from './common/publicConstants';
import { useNavigateWithAppName } from '../../common/NavigateWithAppName';

const PublicBusinessEntitiesPage = () => {
	const navigate = useNavigateWithAppName();
	const [currentStep] = useState<number>(3);

	// Ensure the user has accepted the terms, selected a client type, and is a business owner to access this page.
	useRequireProgress([ctxTermsAccepted, ctxClientTypeSelected, ctxClientBasicInfoCompleted], businessOwnerClientType);

	const handleBackButtonClick = () => {
		navigate(publicClientFamilyPageUrl);
	};

	const handleContinueButtonClick = () => {
		navigate(publicClientInterestsPageUrl);
	};

	return (
		<PublicAutoLogoutLayout>
			<Helmet>
				<title>Join Kelly+Partners | Prospective Client</title>
			</Helmet>
			<Tile>
				<PublicPageSteps currentStep={currentStep} />
				<PublicBusinessEntitiesGrid
					onBackButtonClick={handleBackButtonClick}
					onContinueButtonClick={handleContinueButtonClick}
				/>
			</Tile>
		</PublicAutoLogoutLayout>
	);
};

export default PublicBusinessEntitiesPage;
